import axios from "axios";
import { useEffect, useState } from "react";

const CLIENT_ID = import.meta.env.VITE_SPOTIFY_CLIENT_ID;
const REDIRECT_URI =
  import.meta.env.VITE_SPOTIFY_REDIRECT_URI || window.location.origin;
const SCOPES = "user-read-playback-state user-read-currently-playing";

const SPOTIFY_TOKEN_ENDPOINT =
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "localhost"
    ? "http://localhost:8888/api/spotify-token"
    : "/api/spotify-token";

function getAuthUrl() {
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    response_type: "code",
    redirect_uri: REDIRECT_URI,
    scope: SCOPES,
  });
  return `https://accounts.spotify.com/authorize?${params.toString()}`;
}

export function useSpotifyAuth() {
  const [token, setToken] = useState<string | null>(() => {
    return localStorage.getItem("spotify_token");
  });

  useEffect(() => {
    if (window.location.pathname === "/callback") {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      if (code) {
        axios
          .post(SPOTIFY_TOKEN_ENDPOINT, { code })
          .then((res) => {
            const accessToken = res.data.access_token;
            if (accessToken) {
              localStorage.setItem("spotify_token", accessToken);
              setToken(accessToken);
              window.location.replace("/");
            }
          })
          .catch(() => {
            window.location.replace("/");
          });
      }
    }
  }, []);

  const login = () => window.location.assign(getAuthUrl());
  const logout = () => {
    setToken(null);
    localStorage.removeItem("spotify_token");
  };

  return { token, login, logout };
}
